// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__fo1GF","disabled":"FileBtn_disabled__fwzVK","warn":"FileBtn_warn__2Prg5","fade":"FileBtn_fade__3Ksjq"};